import useAsyncFn from 'react-use/lib/useAsyncFn';
import { setUser, setUserKycInitiatedDate } from '../../../apis/user/store';
import { UserData } from '../../../apis/user/types';
import { useLazyKycLinkQuery } from '../../../apis/user/api';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useCurrentUser } from '../../../apis/user/use';
import { useOpenLink } from '../../../util/hooks/useOpenLink';

export function useOpenUserKyc() {
  const { t } = useTranslation(['kyc']);
  const user = useCurrentUser();
  const [getCerificationLinkUrl, { isLoading: loadingVerification }] =
    useLazyKycLinkQuery();
  const dispatch = useDispatch();

  const openLink = useOpenLink({
    title: t('modal.title'),
    description: t('modal.description'),
    okLabel: t('modal.ok'),
  });

  const [{ loading: openingModal }, openKyc] = useAsyncFn(
    async (category: string, level: number) => {
      const { link: kycLink } = await getCerificationLinkUrl({
        category,
        level,
      }).unwrap();

      dispatch(setUser({ ...(user as UserData), KYCMonitoring: true }));
      dispatch(setUserKycInitiatedDate(new Date()));

      openLink(kycLink);
    },
    [getCerificationLinkUrl, openLink],
  );

  return {
    loadingLink: loadingVerification || openingModal,
    openKyc,
  };
}
